import RxShoppingCart from "../../components/RxShoppingCart";

const CartPage = () => {
	return <RxShoppingCart />;
};

export default CartPage;
